import { track } from '../../analytics/events';

export const choiceAnalytics = () => ({
  mailForwardingOptOut: (id) => track('ElementClicked', {
    webElement: {
      elementType: 'BUTTON',
      text: id === 1 ? 'Mail Forwarding Removed' : 'Informed Delivery',
    },
    actionOutcome: id === 1 ? 'MAIL_FORWARDING_OPT_OUT' : 'TOGGLE_OFF',
  }),
});
export const desktopAnalytics = () => ({
  //  button click events
  click: {
    back: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Back',
      },
      actionOutcome: 'INTERNALLINK',
    }),
    edit: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Edit',
      },
      actionOutcome: 'INTERNALLINK',
    }),
    next: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Next',
      },
      actionOutcome: 'INTERNALLINK',
    }),
  },
});

// these are the same but they could possibly change, keeping them separate for now
export const mobileAnalytics = () => ({
  //  button click events
  input: {
    emf: (value) => track('FieldInteracted', {
      userInputField: {
        fieldType: 'DROPDOWN',
        fieldName: 'extended-mail-forwarding',
        fieldLabel: 'Extension Forward Extension',
        fieldValue: value,
      },
      formContext: {
        formName: 'VERIFY_INFO',
      },
    }),
  },
  click: {
    back: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Back',
      },
      actionOutcome: 'INTERNALLINK',
    }),
    edit: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Edit',
      },
      actionOutcome: 'INTERNALLINK',
    }),
    next: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Next',
      },
      actionOutcome: 'INTERNALLINK',
    }),
    removeEMF: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Remove',
      },
      actionOutCome: 'REMOVE_EMF',
    }),
    removeInformedDelivery: () => track('ElementClicked', {
      webElement: {
        elementType: 'BUTTON',
        text: 'Remove',
      },
      actionOutcome: 'REMOVE_INFORMED_DELIVERY',
    }),
  },
});
